<template>
    <div class="page-warpper indexRule">
        <div class="part-panel" data-index='pro'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg">
                <img src="../assets/images/index/cnt-pro.png" alt="">
            </div>
        </div>
        <div class="part-panel" data-index='prize'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg" >
                <img src="../assets/images/index/cnt-prize.png" alt="">
            </div>
        </div>
        <div class="part-panel" data-index='rule'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg part-txt">
                <p><span class='txt-yellow'>【海选50强】</span>综合导师评分（70%）和听众投票（30%）选出。听众每个ID每日在网页活动页可投5票，在APP活动页可投10票。</p>
                <p><span class='txt-yellow'>【50进20强】</span>导师线上抢人，组建战队。</p>
                <p><span class='txt-yellow'>【20进10强】</span>综合导师评分（70%）和鉴音团投票（30%）选出。</p>
                <p><span class='txt-yellow'>【巅峰争霸赛】</span>综合导师评分（70%）、媒体评审团（20%）和观众投票（10%）选出。</p>
            </div>
        </div>
        <div class="part-panel" data-index='judge'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg">
                <img src="../assets/images/index/cnt-judge.png" alt="">
            </div>
        </div>
        <div class="part-panel" data-index='notice'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg">
                <ul  class='part-txt'>
                    <li>1）参赛作品需为参赛者原创，不得剽窃、抄袭、侵犯他人权利，否则将被直接取消比赛及获奖资格，由此产生的与第三方的纠纷与指导单位、承办方无关，给指导单位、承办方造成的损失由本人承担全部法律责任。</li>
                    <li>2）参赛作品须是未在市级或以上创作类比赛中获奖的，作者拥有该歌曲完整且未授权他人使用的合法版权。</li>
                    <li>3）参赛作品不得违反国家法律法规，不得含有色情，暴力，血腥等不良内容。</li>
                    <li>4）参赛作品若为多人共同创作完成，除另有约定外，其版权归属著作权人共同所有。</li>
                    <li>5）奖品为整首参赛作品的奖品。如获奖作品为共同创作完成，则由共同所有人自主分配，如产生纠纷，与指导单位和承办方无关。所有奖励将在结果公布后陆续发放，因个人原因未能成功领取奖品则视为放弃奖品。</li>
                    <li>6）参赛作品一经投稿则授权指导单位和承办方在全世界范围内通过如下方式使用：</li>
                    <li style='text-indent:1em'>a. 有权在电视媒体、纸质媒体、互联网新闻平台、微博、微信等宣传媒体上以任何方式作宣传、推广使用。</li>
                    <li style='text-indent:1em'>b. 有权使用授权作品、授权素材（包括但不限于授权人个人信息等素材）的复制权、表演权、广播权、信息网络传播权、表演者权、录音录像制作者权，并有权转授权第三方使用授权作品。</li>
                    <li style='text-indent:1em'>c. 有权在向用户提供音乐作品或对音乐作品进行宣传、推广时，使用词曲作者、表演者（歌手）之姓名、照片、肖像等。</li>
                    <li>7）参赛者同意指导单位使用获奖作品申请其相关荣誉。</li>
                    <li>8）一个参赛账号报名一个参赛类型，限制上传3部作品。</li>
                    <li>9）本次活动禁止刷票，情节严重者取消参赛资格。</li>
                    <li>10）海选结果公布后，请留意5sing站内短信并保持通讯通畅，以便工作人员取得联系，逾期未提交或因个人原因无法参与下阶段比赛者视为放弃。</li>
                    <li>11）本次大赛最终解释权归5sing所有。</li>
                </ul>
            </div>
        </div>
        <div class="part-panel">
            <div  class="part-warpper" data-index='sponsor'>
                <div data-index='1'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item md" href="javascript:void(0);" ></a>
                        <a class="part-item kugou" href="javascript:void(0);" ></a>
                        <a class="part-item sing" href="javascript:void(0);" ></a>
                    </div>
                </div>
                <div data-index='2'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item " href="javascript:void(0);" ></a>
                    </div>
                </div>
                <div data-index='3'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item za" href="javascript:void(0);" ></a>
                        <a class="part-item yd" href="javascript:void(0);" ></a>
                        <a class="part-item grt" href="javascript:void(0);" ></a>
                        <a class="part-item sy" href="javascript:void(0);" ></a>
                        <p class='txt'>(排序不分先后)</p>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'indexRule',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../assets/sass/cmn.scss";
.txt-head{
    font-size: 24px;
    font-weight: 600;
    color: #7be5ff;
    text-align: center;
}
.txt-yellow{
    color: #fffc00;
}
.part-panel[data-index="pro"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-pro.png'));
    }
}
.part-panel[data-index="prize"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-prize.png'));
    }
    .part-body{
        padding-top: 0;
    }
}
.part-panel[data-index="rule"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-rule.png'));
    }
}
.part-panel[data-index="judge"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-judge.png'));
    }
    .part-body{
        padding-top: 0;
    }
}
.part-panel[data-index="notice"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-notice.png'));
    }
}
</style>



// WEBPACK FOOTER //
// src/components/index-rule.vue